import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonConfig } from 'src/app/models/button.component.model';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss']
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class WarningDialog implements OnInit {
  public confirmMessage: string;
  public newIconClass: string;
  iconClass = 'Bosch-Ic-notification-warning';
  buttonConfig = [
    new ButtonConfig('Cancel', false, true, () => this.close(false))
  ];

  constructor(public dialogRef: MatDialogRef<WarningDialog>) {}

  ngOnInit() {
    if (this.newIconClass !== undefined && this.newIconClass !== '') {
      this.iconClass = this.newIconClass;
    }
  }

  close(confirm: boolean) {
    this.dialogRef.close(confirm);
  }
}
